import http from "./httpService";


export const saveForm = (id,serviceName, data) => {
    return http.post(`/form/${id}/${serviceName}`, data);
};
